import React from "react";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { colors, spacing, typography, borderRadius } from "../../theme/tokens";
import LineQR from "../views/pages/communication/LineQR.png";

// お問い合わせQRモーダル
// ヘッダーや各セクションのCTAボタンから useContactDialog().open() で開く

const LINE_URL = "https://lin.ee/0pT8myS";

interface ContactDialogContextValue {
  open: () => void;
}

const ContactDialogContext = React.createContext<ContactDialogContextValue>({
  open: () => {},
});

export const useContactDialog = () => React.useContext(ContactDialogContext);

export const ContactDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const contextValue = React.useMemo(
    () => ({ open: () => setIsOpen(true) }),
    []
  );

  return (
    <ContactDialogContext.Provider value={contextValue}>
      {children}
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="xs"
        fullWidth
        aria-labelledby="contact-dialog-title"
        PaperProps={{ sx: { borderRadius: borderRadius.xl } }}
      >
        <IconButton
          onClick={() => setIsOpen(false)}
          aria-label="お問い合わせを閉じる"
          sx={{
            position: "absolute",
            top: spacing[300],
            right: spacing[300],
            color: colors.neutral[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ p: spacing[800], textAlign: "center" }}>
          <Typography
            id="contact-dialog-title"
            variant="h2"
            sx={{
              fontSize: typography.fontSize.xl,
              fontWeight: typography.fontWeight.bold,
              color: colors.neutral[900],
            }}
          >
            お問い合わせ
          </Typography>
          <Typography
            sx={{
              mt: spacing[200],
              fontSize: typography.fontSize.sm,
              color: colors.neutral[600],
            }}
          >
            公式LINEアカウントより受け付けています
          </Typography>
          <Box
            component="a"
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LINEの友だち追加ページを開く"
            sx={{
              display: "inline-block",
              mt: spacing[600],
              borderRadius: borderRadius.lg,
              border: `1px solid ${colors.neutral[200]}`,
              overflow: "hidden",
              lineHeight: 0,
            }}
          >
            <img
              src={LineQR}
              alt="LINE友だち追加のQRコード"
              style={{ width: "220px", maxWidth: "100%" }}
            />
          </Box>
          <Typography
            sx={{
              mt: spacing[500],
              fontSize: typography.fontSize.sm,
              color: colors.neutral[600],
              lineHeight: typography.lineHeight.relaxed,
            }}
          >
            QRコードをスマホでスキャンするとLINEの友だちに追加できます。
            スマホの方はQRをタップすることで遷移できます。
          </Typography>
        </Box>
      </Dialog>
    </ContactDialogContext.Provider>
  );
};
